import moment from 'moment/moment'
import request from '@/utils/request'
const list = () => {
  const iqueryParam =  'SAT.GetDataListByTypeCodeAndTimes|1|String;FY4A_HDF_S_IR1_P2|' +
                      'DateTime;' + moment(new Date()).format('YYYY-MM-DD 00:00:00') +
                      '|DateTime;' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
                      '|Int32;20|Int32;-1'
  const params = {
    calltype: 4,
    iquery: iqueryParam,
  }
  return request.get('/Weather/SAT.aspx', params).then((data: any) => {
    if (!data || !data.Rows || data.Rows.length === 0) {
      return []
    }
    return data.Rows.reverse()
  })
}
export default { list }
